import { useTranslation } from 'react-i18next';
import { ShoppingBag, Truck, CreditCard, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function HowItWorksSection() {
  const { t } = useTranslation();
  
  const steps = [
    {
      id: 1,
      name: t('home.howItWorks.step1.title'),
      description: t('home.howItWorks.step1.description'),
      icon: ShoppingBag,
      color: 'bg-blue-500'
    },
    {
      id: 2,
      name: t('home.howItWorks.step2.title'),
      description: t('home.howItWorks.step2.description'),
      icon: CreditCard,
      color: 'bg-green-500'
    },
    {
      id: 3,
      name: t('home.howItWorks.step3.title'),
      description: t('home.howItWorks.step3.description'),
      icon: Truck,
      color: 'bg-purple-500'
    },
    {
      id: 4,
      name: t('home.howItWorks.step4.title'),
      description: t('home.howItWorks.step4.description'),
      icon: CheckCircle,
      color: 'bg-yellow-500'
    }
  ];
  
  return (
    <div className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            {t('home.howItWorks.title')}
          </h2>
          <p className="mt-4 text-lg text-gray-500">
            {t('home.howItWorks.subtitle')}
          </p>
        </div>
        
        <div className="relative">
          {/* Connecting line */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-0.5 bg-gray-200 transform -translate-y-1/2 z-0"></div>
          
          <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
            {steps.map((step) => (
              <div key={step.id} className="relative z-10">
                <div className="flex flex-col items-center">
                  <div className={`flex items-center justify-center w-12 h-12 rounded-full ${step.color} text-white mb-4`}>
                    <step.icon className="h-6 w-6" />
                  </div>
                  <div className="bg-white p-6 rounded-lg shadow-lg text-center w-full">
                    <h3 className="text-lg font-medium text-gray-900 mb-2">{step.name}</h3>
                    <p className="text-sm text-gray-500">{step.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="mt-12 text-center">
          <Link to="/products">
            <Button variant="primary" className="px-8 py-3 text-base font-medium">
              {t('home.howItWorks.cta')}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}